import DashboardIcon from "@material-ui/icons/Dashboard";
import EventNoteIcon from "@material-ui/icons/EventNote";
import ListAltIcon from "@material-ui/icons/ListAlt";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import CancelPresentationIcon from "@material-ui/icons/CancelPresentation";
import ReportProblemIcon from "@material-ui/icons/ReportProblem";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import PieChartIcon from "@material-ui/icons/PieChart";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import {
  AllInbox,
  ReportOffOutlined,
  SearchOutlined,
} from "@material-ui/icons";
import Timeline from "@material-ui/icons/Timeline";
import Assessment from "@material-ui/icons/Assessment";
import EmojiEvents from "@material-ui/icons/EmojiEvents";
import Spellcheck from "@material-ui/icons/Spellcheck";
import HistoryIcon from "@material-ui/icons/History";

export const Reportsdata = [
 {
    title: "General",
    linkdata: [
      // {
      //   id: 2.1,
      //   name: "Daily Dashboard",
      //   type: "link",
      //   path: "/admin/dailyreport",
      //   validity: true,
      //   page_status: true,
      //   icon: DashboardIcon,
      // },
      {
        id: 2.2,
        name: "Attendance Report",
        type: "link",
        path: "/admin/attendancereport",
        validity: true,
        page_status: true,
        icon: PlaylistAddCheckIcon,
      },
      // {
      //   id: 2.3,
      //   name: "Monthly Exam Report",
      //   type: "link",
      //   path: "/admin/montlyexamreport",
      //   validity: true,
      //   page_status: true,
      //   icon: EventNoteIcon
      // },
      // {
      //   id: 2.3,
      //   name: "Distinct Paper Report",
      //   type: "link",
      //   path: "/admin/distinctpapercodereport",
      //   validity: true,
      //   page_status: true,
      //   icon: HourglassEmptyIcon
      // },
    ],
  },

  {
    title: "Results",
    linkdata: [
      {
        id: 3.1,
        name: "Rank Wise Report",
        type: "link",
        path: "/admin/rankwisereport",
        validity: true,
        page_status: true,
        icon: EmojiEvents
      },

      {
        id: 3.2,
        name: "Section Wise Report",
        type: "link",
        path: "/admin/sectionwisereport",
        validity: true,
        page_status: true,
        icon:ListAltIcon
      },
       {
        id: 102,
        name: "Monthly Section Wise Report",
        type: "link",
        path: "/admin/monthlysectionreport",
        validity: true,
        page_status: true,
      },
      {
        id: 3.3,
        name: "Response Report",
        type: "link",
        path: "/admin/responsereport",
        validity: true,
        page_status: true,
        icon: Timeline
      },
      {
        id: 3.4,
        name: "Consolidated Report",
        type: "link",
        path: "/admin/consolidatereport",
        validity: true,
        page_status: true,
        icon: PieChartIcon,
      },
    ],
  },
];
